import React from 'react';
import { Input } from '@/components/ui/input';
import { ExternalLink } from 'lucide-react';

interface ApiKeyInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    helpText?: string;
    showKey: boolean;
    name: string;
    sensitive?: boolean;
    externalUrl?: string;
    externalLabel?: string;
    onBlur?: () => void;
    status?: React.ReactNode;
}

const ApiKeyInput: React.FC<ApiKeyInputProps> = ({
    label,
    value,
    onChange,
    placeholder = '',
    helpText = '',
    showKey,
    name,
    sensitive = false,
    externalUrl,
    externalLabel,
    onBlur,
    status
}) => {
    return (
        <div className="space-y-2">
            <label className="text-sm font-medium">{label}</label>
            <div className="relative">
                <Input
                    type={sensitive && !showKey ? "password" : "text"}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    name={name}
                    className={externalUrl ? 'pr-11' : undefined}
                />
                {externalUrl && (
                    <a
                        href={externalUrl}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={externalLabel || label}
                        title={externalLabel || label}
                        className="absolute right-1 top-1 flex h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 hover:text-purple-600"
                    >
                        <ExternalLink className="h-4 w-4" />
                    </a>
                )}
            </div>
            {status}
            {helpText && <p className="text-sm text-gray-500">{helpText}</p>}
        </div>
    );
};

export default ApiKeyInput;
